module.exports = __webpack_public_path__ + "static/media/evolWe2.63c2e50d.jpg";